<template>
  <div class="menuPage">
    <vue-scroll :style="{'height':menuHeight + 'px'}">
      <el-menu
        class="menuList"
        @select="selectMenu"
        background-color="#46536D"
        text-color="#ABBACF"
        :collapse="isCollapse"
        :default-openeds="submenuIndex"
        active-text-color="#FFF">
        <div class="switchBox" @click="switchCollapse">
          <i class="switchBtn" :class="isCollapse == false ? 'packUp' : 'spread'"></i><span v-if="isCollapse == false">收起菜单</span>
        </div>
        <aside-item :data="permissionsNew"></aside-item>
      </el-menu>
    </vue-scroll>
  </div>
</template>

<script>
import {mapState} from 'vuex';
import { permissions } from '@/service/permissions';
import { baseData } from '@/service/baseData';
import {getAction} from "@/service/http/api";

export default {
  data(){
    return {
      menuHeight:(window.innerHeight - 52),
      permissions:permissions,
      permissionsNew:[],
      baseData:baseData,
      isCollapse:false,
      submenuIndex:[],
      menuData:[],
      url:{
        list:'/permission/queryMenuByUserId'
      }
    }
  },
  computed:{
    ...mapState([
      'openMenu',
    ])
  },
  methods:{
    switchCollapse(){
      this.isCollapse =!this.isCollapse;
    },
    selectMenu(key, keyPath){
      this.addTab({title:baseData[key]['name'],icon:baseData[key]['icon'],componentName:key,params:{}})
    }
  },
  mounted(){
    let _this = this;
    window.onresize = function(){
      _this.menuHeight = window.innerHeight - 52;
    };
    this.submenuIndex = this.openMenu;
  },
  created(){
    // this.permissionsNew = this.toTreeData(this.menuData,{id:"menuId",pId:"parentId"});
    let getFirstChild = function (arr) {
      console.log(arr);
      let temp = arr[0].children && arr[0].children.length >0?getFirstChild(arr[0].children):arr[0];
      return temp;
    };
    let uid = localStorage.getItem('userKey');
    getAction(this.url.list,{uid}).then(res => {
      if(res.code === 200){
        this.menuData = res.data.filter(item=>item.parentId !== "0");
        this.permissionsNew = this.toTreeData(this.menuData,{id:"id",pId:"parentId",name:'menuName'});
        console.log(1111,this.permissionsNew);
        let firstMenu = getFirstChild(this.permissionsNew)
        this.selectMenu(firstMenu.url);
      }
    })
  }
}
</script>
<style lang="scss">
  .menuPage{
    margin-top:52px;
    background: #46536D;
    height: 100%;
    position: relative;

    .switchBox{
      width: 100%;
      height: 36px;
      cursor: pointer;
      box-shadow: inset 0 -1px 0 0 #3F4A62, inset 0 1px 0 0 #4C5976;
      .switchBtn{
        display: block;
        float: left;
        width: 16px;
        height: 100%;
        margin-left: 22px;

        &.packUp{
          background: url("../../assets/icon/arrow-left.svg") no-repeat center;
        }
        &.spread{
          background: url("../../assets/icon/arrow-right.svg") no-repeat center;
        }
      }
      span{
          display:block;
          float: left;
          line-height: 36px;
          margin-left: 12px;
          color:#ABBACF;
        }
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/basics/asideMenu.vue